import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { GraduationCap, X } from "lucide-react";
import { useT } from "@/lib/LanguageContext";
import { adminHref } from "./adminPath";

/**
 * AcademyProUpsell — soft upsell (dismissible) affiché quand un praticien
 * Flow franchit un seuil Academy (>1 cours publié ou >50 inscrits).
 */
export default function AcademyProUpsell() {
  const t = useT("admin");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/tenant/upsell/academy-pro")
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, []);

  const dismiss = async () => {
    setData(null);
    try { await api.post("/tenant/upsell/academy-pro/dismiss"); } catch { /* non-bloquant */ }
  };

  if (!data?.eligible) return null;

  return (
    <div
      data-testid="academy-pro-upsell"
      className="relative flex items-center gap-5 rounded-3xl p-6 bg-gradient-to-br from-sol-midnight via-sol-slate to-sol-midnight text-sol-ivory border border-sol-gold/30 overflow-hidden"
    >
      <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-sol-gold/10 blur-3xl" />
      <div className="w-12 h-12 rounded-2xl bg-sol-gold/20 flex items-center justify-center flex-shrink-0 relative">
        <GraduationCap className="w-6 h-6 text-sol-gold" />
      </div>
      <div className="flex-1 min-w-0 relative">
        <div className="text-[10px] uppercase tracking-wider text-sol-gold/80 mb-0.5">{t("upsell.academyPro.badge")}</div>
        <div className="font-sol text-lg font-semibold">{t("upsell.academyPro.title")}</div>
        <div className="text-sm text-sol-ivory/60 mt-0.5">
          {data.reason ? `${data.reason} · ` : ""}{t("upsell.academyPro.description")}
        </div>
      </div>
      <Link
        to={adminHref("/admin/billing")}
        data-testid="academy-pro-cta"
        className="relative whitespace-nowrap text-sm font-semibold bg-sol-gold text-sol-midnight px-4 py-2 rounded-full hover:bg-sol-gold/90 transition"
      >
        {t("upsell.academyPro.cta")}
      </Link>
      <button onClick={dismiss} data-testid="academy-pro-dismiss" className="relative text-sol-ivory/40 hover:text-sol-ivory">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
